import { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

interface IGuardedRouteProps {
    condition: boolean;
    redirectPath?: string;
    children: ReactNode;
}

const GuardedRoute: FC<IGuardedRouteProps> = ({ condition, redirectPath, children }) => {
    const location = useLocation();

    if (!condition) {
        return <Navigate to={redirectPath ?? `/login${location.search}`} />;
    }
    return <>{children}</>;
};

export default GuardedRoute;
